// Ce qui a déjà raté (une croix par méthode), puis le retournement : le
// soleil pointillé du matin (public/media/dot-sun.webp) et « Remove the option. ».
import { useT } from '../../lib/i18n'
import { Cross } from './Icons'

const PUB = process.env.PUBLIC_URL || ''

export default function Problem () {
  const p = useT().problem
  return (
    <section className="lp-night" id="night">
      <img className="lp-night__moon" src={`${PUB}/media/dot-moon.webp`} alt="" aria-hidden="true" width="360" height="360" />
      <div className="lp-wrap lp-night__in">
        <div className="lp-night__head lp-rv">
          <span className="lp-kicker lp-kicker--night">{p.kicker}</span>
          <h2 className="lp-h2 lp-h2--night">{p.title}</h2>
          <p className="lp-lead lp-lead--night">{p.lead}</p>
        </div>

        <div className="lp-tried lp-rv">
          <span className="lp-tried__k">{p.triedK}</span>
          <ol>
            {p.tried.map((x, i) => (
              <li key={x.t}>
                <span className="lp-tried__n">0{i + 1}</span>
                <span className="lp-tried__t"><span className="lp-mk lp-mk--n"><Cross /></span>{x.t}</span>
                <span className="lp-tried__why">{x.why}</span>
              </li>
            ))}
          </ol>
        </div>
      </div>

      <div className="lp-wrap">
        <div className="lp-after lp-rv">
          <figure className="lp-after__img">
            <span className="lp-after__dots" aria-hidden="true" />
            <img className="lp-after__lock lp-after__sun" src={`${PUB}/media/dot-sun.webp`} alt="" loading="lazy" decoding="async" width="360" height="360" />
            <span className="lp-after__chip"><b>{p.afterTime}</b>{p.afterChip}</span>
          </figure>
          <div className="lp-after__txt">
            <span className="lp-kicker">{p.afterK}</span>
            <p className="lp-turn">
              <span>{p.turn1}</span>
              <em>{p.turn2}</em>
            </p>
            <p className="lp-lead">{p.afterP}</p>
          </div>
        </div>
      </div>
    </section>
  )
}
